exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-dialog>.el-dialog__header{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71a3642d","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/dispatches/partials/Preview.vue
// module id = MYq/
// module chunks = 0